import WaterRoad from './WaterRoad.vue';

export default WaterRoad;
